import styled from "styled-components";

export const CreateUserIcon = styled.i`
    font-size: 2.2em !important;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    box-shadow: 4px 3px 5px ${props => (props.disabled ? "#fff" : "#888888")};
    border-radius: 20px;
    color: ${props => (props.disabled ? "#888" : "#52816d")};
`;
